module.exports = __webpack_public_path__ + "media/images/check-74b152a66dd67e514f98ca32320a00a4.svg";